export const makeGraphCodeId = () => {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
    return `${Date.now()}_${Math.floor(Math.random() * 1e9)}`;
  };
  
export const normalizeGraphsToArray = (graphData) => {
    if (!graphData) return [];
    return Array.isArray(graphData) ? graphData : [graphData];
};

export const attachGraphCodeId = (graphsArray, codeId) => {
    return graphsArray.map(g => ({ ...g, _codeId: codeId }));
};

export const buildPrevGraphCodeContext = (blk) => {
    const codes = Array.isArray(blk?.graphCodes) ? blk.graphCodes : [];
    if (!codes.length) return "";

    const wrapped = codes
        .map((c, i) => `<Needed graph code ${i + 1}>${c.code || ""}</Needed graph code ${i + 1}>`)
        .join("\n");

    return `\n\nPlease make sure to have these graphs show up:\n${wrapped}`;
};

export const normalizeLoadedBlocks = (blocks) => {
    return blocks.map((b) => {
      const graphs = Array.isArray(b.graphs) ? b.graphs : (b.graphs ? [b.graphs] : []);
      const graphCodes = Array.isArray(b.graphCodes) ? b.graphCodes : [];
  
      // If old graphs had no _codeId, group them under a legacy id
      // (no code attached, but this helps deletion logic stay consistent)
      const legacyId = `legacy_${b.id}`;
  
      const normalizedGraphs = graphs.map((g) => {
        if (g && typeof g === "object" && !g._codeId) {
          return { ...g, _codeId: legacyId };
        }
        return g;
      });
  
      return {
        ...b,
        graphs: normalizedGraphs,
        graphCodes,
        collapsed: false,
      };
    });
  };